/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { HOST_SERVER } from '../utils/configs';
import MenuItems from "../assets/json/menuAkasa.json";
import MenuItemsSec from "../assets/json/menuSandbox.json";
import { useTranslation } from 'react-i18next';
import { Footer } from '../common';
import { Authorizer } from 'casbin.js';


const MENU_STATE_COLLAPSE = 'collapsed';

const isPathActive = (pathname, path) =>
  typeof path === 'string' && path.startsWith('/') &&
  (pathname === path || pathname.startsWith(`${path}/`));

const MenuLink = (props) => {
  const { t } = useTranslation();
  const { item, icon, subItems, menuState } = props;
  const location = useLocation();
  const active = isPathActive(location.pathname, item.path);
  const noSubMenu = (!subItems || subItems.length === 0);

  let cls = noSubMenu && active ? "current" : "";

  const onClick = (e) => {
    e.preventDefault();
    props.onMenuClick(e);
    if (noSubMenu) {
      props.onNavigate();
    }
  }

  return (
    <button 
      className={`menu-item-head ${cls}`} 
      onClick={onClick}
      title={menuState === 'collapsed' ? item.title : ''}
    >
      <div className='menu-item-content'>
        <div className='menu-item-left'>
         <i className={`menu-icon ${icon}`}/>
          <span className="path1"></span>
          <span className="path2"></span>
   
          {menuState !== MENU_STATE_COLLAPSE && (
            <span className='menu-title'>{t(`pages.${item.key}`)}</span>
          )}
        </div>
        {menuState !== MENU_STATE_COLLAPSE && !noSubMenu  &&  (
          <i className={`menu-caret ${noSubMenu ? 'icon-caret-right' : 'icon-caret-down'}`} />
        )}
      </div>
    </button>
  );
}

const SubMenu = (props) => {
  const { t } = useTranslation();
  const { item, subItem } = props;
  const subItems2 = subItem.subItems2 || [];
  const isHeader = subItem.type === 'menuHeader';
  const [expanded, setExpanded] = useState(true);
  const childrenId = `${item.key}-${subItem.key}-children`;
  const location = useLocation();
  const active = isPathActive(location.pathname, subItem.path) ||
    subItems2.some(child => isPathActive(location.pathname, child.path));
  useEffect(() => {
    if (active) setExpanded(true);
  }, [location.pathname, active]);
  const onClick = (e) => {
    e.preventDefault();
    if (isHeader) {
      setExpanded(previous => !previous);
      return;
    }
    props.onNavigate();
  }
  
  return (
    <div className={isHeader ? `sub-menu-group menu-header ${expanded ? 'open' : 'closed'} ${active ? 'active' : ''}` : undefined}>
      <button
        type="button"
        className={`${isHeader ? 'sub-menu-group-head' : 'sub-menu-item'} ${active ? 'active' : ''}`}
        aria-expanded={isHeader ? expanded : undefined}
        aria-controls={isHeader ? childrenId : undefined}
        onClick={onClick}
      >
        <span className={isHeader ? 'sub-menu-group-title' : 'sub-menu-text'}>
          {t(`pages.${item.key}Sub.${subItem.key}`)}
        </span>
        {isHeader && <i className="menu-caret icon-caret-down" aria-hidden="true" />}
      </button>
      {subItems2.length > 0 && (
        <div id={childrenId} className={isHeader ? 'sub-menu-group-list' : 'sub-menu-sub-items'} hidden={isHeader && !expanded}>
              {subItems2.map((subItem2) => (
                <button key={subItem2.key} type="button" className={`sub-menu-item ${isPathActive(location.pathname, subItem2.path) ? 'active' : ''}`} onClick={(e) => { e.preventDefault(); props.onNavigate(subItem2); }}>
                  <span className="sub-menu-text">
                    {t(`pages.${item.key}Sub.${subItem.key}Sub2.${subItem2.key}`)}
                  </span>
                </button>
              ))}
        </div>
      )}
    </div>
  )
}

const MenuItem = (props) => {
  const { item, selected, menuState, current } = props;
  const { subItems, icon } = item;
  const isActive = selected?.key === item.key;
  const hasSubItems = Array.isArray(subItems) && subItems.length > 0;

  const onClickMenu = (e) => {
    e.preventDefault();
    props.onClick && props.onClick(isActive ? '' : item)
  }

  return (
    <div className={`menu-item-wrapper ${isActive ? 'active' : ''} ${current ? 'current' : ''}`}>
      <MenuLink 
        item={item} 
        icon={icon} 
        subItems={subItems}
        key={item.key} 
        menuState={menuState}
        onNavigate={() => {
          if (!hasSubItems) {
            props.onNavigate(item);
          }
        }}
        onMenuClick={(e) => onClickMenu(e)}
      />

      {/* Sub menu items */}
      {hasSubItems && (
        <div 
          className='sub-menu-container' 
          style={{ maxHeight: isActive && menuState !== MENU_STATE_COLLAPSE ? 'none' : 0 }}
        >
          <div className='sub-menu-list'>
            {subItems.map(subItem => (
              <SubMenu
                item={item}
                subItem={subItem}
                key={subItem.key}
                onNavigate={(subItem2) => props.onNavigate(item, subItem, subItem2)}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
export const getCurrentMenuItem = (location, menuItems = HOST_SERVER === process.env?.REACT_APP_API_SERVER ? MenuItems : MenuItemsSec) => {
  const pathname = location?.pathname;
  if (!pathname) return null;
  let match = null;
  let matchedPathLength = -1;

  menuItems.forEach((menu, index) => {
    const consider = (path, subMenu, child, level) => {
      if (!isPathActive(pathname, path) || path.length <= matchedPathLength) return;
      matchedPathLength = path.length;
      match = {
        title: menu,
        id: index,
        subTitle: subMenu,
        subMenuItem2: level === 2 ? child : undefined,
        subMenuItem3: level === 3 ? child : undefined,
        subMenuItem4: level === 4 ? child : undefined
      };
    };
    consider(menu.path);
    consider(`/${menu.key}`);
    (menu.subItems || []).forEach(subMenu => {
      consider(subMenu.path, subMenu);
      [2, 3, 4].forEach(level => {
        (subMenu[`subItems${level}`] || []).forEach(child =>
          consider(child.path, subMenu, child, level)
        );
      });
    });
  });
  return match;
}

export const SidebarComponent = (props) => {
  const [state, setState] = useState({ selected: '' });
  const [MenuItemsList, setMenuItemsList] = useState([]);
  const [permissionObj, setPermissionObj] = useState({});
  const [activeMenu, setActiveMenu] = useState(null);
  const [authorizer] = useState(new Authorizer('manual'));
  const hostType = localStorage.getItem('sType');
  const userRole = localStorage.getItem('userRole')
  const permissions = localStorage.getItem("userPermissions");

  const navigate = useNavigate();
  const location = useLocation();

  const convertPath = (originalPath) => {
    if (originalPath) {
      const parts = originalPath.split('.');
      const lastPart = parts[parts.length - 1];
      if (lastPart !== 'alerts') {
        return `/${lastPart}`;
      } else {
        return `/alertsWarnings`;
      }
    }
  }

useEffect(() => {
  const currentMenuItem = getCurrentMenuItem(location, MenuItemsList);
  setActiveMenu(currentMenuItem);
  
  if (currentMenuItem && currentMenuItem.title) {
    setState({ selected: currentMenuItem.title });
  }
}, [location.pathname, MenuItemsList]);


  useEffect(() => {
    if (hostType && userRole) {
      if (permissions) {
        const permissionsObject = JSON.parse(permissions);
        const cleanedUserRole = userRole.replace(/"/g, "");
        authorizer.setPermission(permissionsObject[cleanedUserRole]);
        setPermissionObj(authorizer.permission);
      }
    }
  }, [props, hostType, userRole, permissions]);

  useEffect(() => {
    if (authorizer && authorizer?.permission) {
      setPermissionObj(authorizer?.permission)
    }
  }, [props, hostType]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.clear();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (permissionObj) {
      const { actObjData } = permissionObj;
      let ngoMenu = HOST_SERVER === process.env?.REACT_APP_API_SERVER ? MenuItems : MenuItemsSec;
      if (ngoMenu) {
        setMenuItemsList(
          ngoMenu.map(ml => {
            if (!ml) return null;

            if (ml?.type && ml.type === "menuHeader") {
              // Menu Header
              return ml;
            }
            else {
              // Regular Menu Item
            }

            if (actObjData && actObjData.has('view')) {

              const urls = actObjData.get('view');
              if (Array.isArray(urls)) {
                if (urls.some(p => p === ml.pathPermission)) {
                  const filteredSubItems = ml.subItems
                        ? ml.subItems
                            .map(sI => sI.type === "menuHeader"
                              ? { ...sI, subItems2: (sI.subItems2 || []).filter(child => urls.some(s => s === child.pathPermission)) }
                              : sI)
                            .filter(sI => sI.type === "menuHeader"
                              ? sI.subItems2.length > 0
                              : urls.some(s => s === sI.pathPermission))
                        : [];

                  if (filteredSubItems.length === 0 && (ml.key === 'reports' || ml.key === 'dashboard' || ml.key === 'loyalty' || ml.key === 'alertsWarnings')) {
                    return {
                      ...ml,
                      path: convertPath(ml.path),
                      subItems: []
                    };
                  }

                  return {
                    ...ml,
                    subItems: filteredSubItems
                  };
                }
                else if (urls.some(p => p === ml.path)) {
                  const filteredSubItems = ml.subItems
                        ? ml.subItems
                            .map(sI => sI.type === "menuHeader"
                              ? { ...sI, subItems2: (sI.subItems2 || []).filter(child => urls.some(s => s === child.pathPermission)) }
                              : sI)
                            .filter(sI => sI.type === "menuHeader"
                              ? sI.subItems2.length > 0
                              : urls.some(s => s === sI.pathPermission))
                        : [];

                  if (filteredSubItems.length === 0 && (ml.key === 'reports' || ml.key === 'dashboard' || ml.key === 'loyalty' || ml.key === 'alertsWarnings' || ml.key === 'logs')) {
                    return {
                      ...ml,
                      path: convertPath(ml.path),
                      subItems: []
                    };
                  }

                  return {
                    ...ml,
                    subItems: filteredSubItems
                  };
                }
              }
            }
            return null;
          }).filter(item => item !== null)
        );
      }
    }
  }, [permissionObj, hostType]);

  const onNavigate = (item, subItem = null, subItem2 = null) => {
    const selectedSubMenu = subItem || item.subItems?.find(option => option.path || option.subItems2?.length);
    const selectedSubMenu2 = subItem2 || (selectedSubMenu?.type === 'menuHeader' ? selectedSubMenu.subItems2?.[0] : null);
    const path = selectedSubMenu2?.path || selectedSubMenu?.path || item.path;
    if (!path || !path.startsWith('/')) return;

    navigate(path, {
      state: {
        ...location.state,
        title: item,
        subTitle: selectedSubMenu || null,
        sub2Title: selectedSubMenu2 || null,
        subMenuItem2: selectedSubMenu2 || null,
      }
    });
  }

  return (
    <> 
    <div className={`redesigned-sidebar ${props.menuState}`}>
      <div className='menu-list-container sm-scrollbar'>
        {MenuItemsList?.map((item, i) => {
          return (
            <MenuItem
              key={i}
              item={item}
              onClick={(_c) => {
                setState((_) => ({ ..._, selected: _c }))
                props.onMenu(_c);
              }}
              current={activeMenu?.title.key === item.key}
              onNavigate={onNavigate}
              menuState={props.menuState}
              selected={state.selected || ''}
            />
          )
        })}
      </div>
        <Footer mode={props.menuState} />
    </div>
    </>

  );
}
